import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import {
  Bars2Icon,
  XMarkIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { Secundary } from "../buttons/navigation/Secundary";
import { navLogin } from "./options/MenuOptions";
import { lazy, Suspense } from "react";
import { closeSession } from "../../utils/closeSession";
import { HttpRequest } from "../../services/httpRequest";
import { variablesGlobales } from "../../configs/variables";

// Dropdown
const Access = lazy(() => import("./dropdown/Access"));
const MyCount = lazy(() => import("./dropdown/MyCount"));

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function NavbarHome(props) {
  const navigate = useNavigate();
  const hasToken = localStorage.getItem("token");
  const typeUSer = localStorage.getItem("type_user");
  const doc = localStorage.getItem("doc");
  const [firstname, setFirstname] = useState("");

  const handleCloseSession = () => {
    closeSession();
    navigate("/ingresar");
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(doc);
      return data?.message?.info;
    } catch (error) {
      console.log(error);
    }
  };

  const navigation = [
    {
      name: "Requisitos",
      href: "/requisitos",
      current: props.current6,
    },
    {
      name: "Tasas y tarifas",
      href: "/tarifas",
      current: props.current3,
    },
    {
      name: "Preguntas frecuentes",
      href: "/faqs",
      current: props.current5,
    },
    {
      name: "Nosotros",
      href: "/nosotros",
      current: props.current2,
    },
  ];

  useEffect(() => {
    if (!hasToken || !doc) return;
  
    const loadInfo = async () => {
      let info = await loadInfoUser();
      setFirstname(info?.firstname);
    };
  
    loadInfo().catch(console.log);
  }, [hasToken, doc]);

  return (
    <Disclosure
      as="nav"
      className="fixed z-30 w-full bg-white bg-clip-padding backdrop-filter shadow-md font-walsheim text-lg"
    >
      {({ open }) => (
        <>
          <div className="px-4 sm:px-6 2xl:px-36">
            <div className="flex justify-between h-24">
              <div className="grid content-center">
                <div className="flex gap-4">
                  <a className="flex items-center" href="/">
                    <img
                      className="block md:hidden h-12 w-auto"
                      src="/svg/imagotipo-galilea-14.svg"
                      alt="Galilea"
                    />
                    <img
                      className="hidden md:block h-14 w-auto"
                      src="/svg/imagotipo-galilea-01.svg"
                      alt="Galilea"
                    />
                  </a>
                  <div className="hidden xl:flex sm:space-x-8 px-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "relative font-bold after:absolute after:h-1 after:rounded-full after:w-[100%] after:bg-purple"
                            : "",
                          "relative px-1 pt-1 inline-flex items-center after:absolute after:h-1 after:rounded-full after:w-[0%] after:bg-purple after:duration-300 after:z-0 after:bottom-0 hover:after:w-[100%]"
                        )}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              <div className="ml-0 hidden xl:flex lg:items-center">
                <a href="/pagar" className="pr-4">
                  <Secundary text="Pagar mi cuota" />
                </a>
                {/* Profile dropdown */}
                <Suspense fallback={null}>
                  {hasToken && typeUSer === variablesGlobales.typeUSerClient ? (
                    <MyCount name={firstname}></MyCount>
                  ) : (
                    <Access></Access>
                  )}
                </Suspense>
              </div>

              <div className="sm-mr-2 flex items-center xl:hidden">
                {/* Mobile menu button */}
                {
                  <Disclosure.Button className="inline-flex items-center justify-center focus:rounded-red rounded-full p-2 text-tdark hover:text-tdark focus:bg-berry focus:bg-opacity-25 focus:outline-none">
                    {open ? (
                      <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <>
                        <span className="pr-2 font-medium">Menú</span>
                        <Bars2Icon
                          className="block h-6 w-6"
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </Disclosure.Button>
                }
              </div>
            </div>
          </div>

          <Disclosure.Panel className="xl:hidden">
            <div className="pt-2 pb-3 space-y-1">
              {navigation.map((item) => (
                <Disclosure.Button
                  as="a"
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "font-bold border-tdark"
                      : "hover:border-tdark hover:font-bold border-transparent",
                    "text-base block pl-3 pr-4 py-2 border-l-4"
                  )}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
            {hasToken && typeUSer === variablesGlobales.typeUSerClient ? (
              <div className="pt-4 pb-3 border-t border-gray-200">
                <div className="mt-3 space-y-1">
                  <div className="px-4 py-2">
                    <span className="block py-2 text-lg font-bold">
                      Hola, {firstname}
                    </span>
                    {navLogin.map((item) => (
                      <Disclosure.Button
                        as="a"
                        key={item.name}
                        href={item.href}
                        className="block py-2 text-base hover:font-bold"
                      >
                        {item.name}
                      </Disclosure.Button>
                    ))}
                    <hr className="mt-4 text-purple text-opacity-40" />

                    <div className="flex" onClick={handleCloseSession}>
                      <ArrowRightOnRectangleIcon className="w-4 h-auto" />
                      <span className="ml-2 text-sm">Cerrar sesión</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="pl-4 pb-4">
                <Access></Access>
              </div>
            )}
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
